const moment = require('moment');
const attributeTypes = require('./attributeTypes');
module.exports = {
    [attributeTypes.date]: [
        {
            label: 'queryBuilder_operator_before',
            value: 'lt',
            fn: (lvalue, rvalue) => {
                return moment(lvalue).isBefore(rvalue, 'day');
            }
        },
        {
            label: 'queryBuilder_operator_after',
            value: 'gt',
            fn: (lvalue, rvalue) => {
                return moment(lvalue).isAfter(rvalue, 'day');
            }
        },
        {
            label: 'queryBuilder_operator_on',
            value: 'eq',
            fn: (lvalue, rvalue) => {
                return moment(lvalue).isSame(rvalue, 'day');
            }
        },
        {
            label: 'queryBuilder_operator_onOrBefore',
            value: 'lte',
            fn: (lvalue, rvalue) => {
                return moment(lvalue).isSameOrBefore(rvalue, 'day');
            }
        },
        {
            label: 'queryBuilder_operator_onOrAfter',
            value: 'gte',
            fn: (lvalue, rvalue) => {
                return moment(lvalue).isSameOrAfter(rvalue, 'day');
            }
        },
        {
            label: 'queryBuilder_operator_notOn',
            value: 'neq',
            fn: (lvalue, rvalue) => {
                return !moment(lvalue).isSame(rvalue, 'day');
            }
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_empty',
            value: 'empty',
            fn: lvalue => {
                return !!lvalue === false;
            }
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_notEmpty',
            value: 'notEmpty',
            fn: lvalue => {
                return !!lvalue === true;
            }
        },

    ],
    [attributeTypes.enum]: [
        {
            label: 'queryBuilder_operator_is',
            value: 'eq',
            fn: (lvalue, rvalue) => {
                return lvalue === rvalue;
            },
        },
        {
            label: 'queryBuilder_operator_isNot',
            value: 'neq',
            fn: (lvalue, rvalue) => {
                return lvalue !== rvalue;
            },
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_empty',
            value: 'empty',
            fn: lvalue => {
                return !!lvalue === false;
            }
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_notEmpty',
            value: 'notEmpty',
            fn: lvalue => {
                return !!lvalue === true;
            }
        },
    ],
    [attributeTypes.multiSelectEnum]: [
        {
            label: 'queryBuilder_operator_includes',
            value: 'eq', // no include in DA keep it for now
            fn: (lvalue, rvalue) => {
                lvalue = !Array.isArray(lvalue) ? [lvalue] : lvalue;
                if(rvalue) {
                    return rvalue.some(value => lvalue.includes(value));
                }
                return;
            },
        },
        {
            label: 'queryBuilder_operator_doesNotInclude',
            value: 'neq', // no doesNotInclude in DA keep it for now
            fn: (lvalue, rvalue) => {
                lvalue = !Array.isArray(lvalue) ? [lvalue] : lvalue;
                if(rvalue) {
                    return !rvalue.some(value => lvalue.includes(value));
                }
                return;
            },
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_empty',
            value: 'empty',
            fn: (lvalue) => {
                return Array.isArray(lvalue) ? lvalue.length === 0 : !!lvalue === false;
            }
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_notEmpty',
            value: 'notEmpty',
            fn: (lvalue) => {
                return  Array.isArray(lvalue) ? lvalue.length > 0 : !!lvalue === true;
            }
        },
    ],
    [attributeTypes.radioChoiceEnum]: [
        {
            label: 'queryBuilder_operator_is',
            value: 'eq',
            fn: (lvalue, rvalue) => {
                return lvalue === rvalue;   
            },
        },
        {
            label: 'queryBuilder_operator_isNot',
            value: 'neq',
            fn: (lvalue, rvalue) => {
                return lvalue !== rvalue;
            },
        },
    ],
    [attributeTypes.string]: [
        {
            label: 'queryBuilder_operator_contains',
            value: 'contains',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return lvalue.toUpperCase().includes(rvalue.toUpperCase());
                }
                return;
            },
        },
        {
            label: 'queryBuilder_operator_doesNotContain',
            value: 'notContains',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return !lvalue.toUpperCase().includes(rvalue.toUpperCase());
                }
                return true;
            },
        },
        {
            label: 'queryBuilder_operator_endsWith',
            value: 'endsWith',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return lvalue.toUpperCase().endsWith(rvalue.toUpperCase());
                }
                return;
            },
        },
        {
            label: 'queryBuilder_operator_is',
            value: 'eq',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return lvalue.toUpperCase() === rvalue.toUpperCase();
                }
                return;
            },
        },
        {
            label: 'queryBuilder_operator_isNot',
            value: 'neq',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return lvalue.toUpperCase() !== rvalue.toUpperCase();
                }
                return true;
            },
        },
        {
            label: 'queryBuilder_operator_startsWith',
            value: 'startsWith',
            fn: (lvalue, rvalue) => {
                if(lvalue && rvalue) {
                    return lvalue.toUpperCase().startsWith(rvalue.toUpperCase());
                }
                return;
            },
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_empty',
            value: 'empty',
            fn: lvalue => {
                return !!lvalue === false;
            }
        },
        {
            hideValueInput: true,
            label: 'queryBuilder_operator_notEmpty',
            value: 'notEmpty',
            fn: lvalue => {
                return !!lvalue === true;
            }
        },
    ],
};
